import { gql } from "@apollo/client"

export const EDIT_LOCATION_MUTATION = gql(`
 mutation EditLocation($input: EditLocationInput!){
  editLocation(input:$input){
    __typename
    location {
      id
      name
      streetLineOne
      streetLineTwo
      city
      state
      country
      postalCode
      customFields {
        __typename
        id
        name
        description
        type
        required
      }
      totalStaff
      totalStudents
    }  
    errors{
      __typename
      ... on ValidationError{
        message
        errors{
          fieldName
          messages
          }
        }
      }
  }
}`)